<template>
	<div class="form__field__select" :data-error="required && !propModel">
		<div class="form__input__select">
			<vue-select
				:id="name"
				v-bind="inputProps"
				:multiple="false"
				:placeholder="placeholder"
				:value="transformValue"
				@input="$emit('input', $event.id)"
				:disabled="disabled || inputProps?.loading"
				:clearable="false"
				:options="values"
			>
				<template #open-indicator="{ attributes }">
					<img v-bind="attributes" src="/certificacaodigital/images/inputSelect.svg"/>
				</template>
				<template #no-options>
					Não foi encontrado essa busca
				</template>
			</vue-select>
			<div v-show="required && !propModel" className="form_error">
				Campo obrigatório.
			</div>
		</div>
	</div>
	</template>
	<script>
		// @ts-ignore: Not type
	import VueSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
	
	
	export default {
		props: {
			name: String,
			required: Boolean,
			placeholder: String,
			values: Array,
			disabled: {
				required: false,
				default: false,
				type: Boolean
			},
			value: [String, Object],
			selected: String,
			inputProps: Object
		},
		computed: {
			transformValue () {
					const value = this.values?.find(item => {
					return item.id === this.value || item.id === this.value?.id || item === this.value || item === this.value?.id
				})
				return value
			},
		},
		components: {
			VueSelect
		}
	}
	</script>
	<style lang="scss">
	$color_error: #F53D3D;
	
		.form__field__select {
			width: 100%;
			.form__label {
				text-wrap: nowrap;
			}
			.form__input__select {
				position: relative;
				.vs__selected-options {
					align-items: center;
					flex-wrap: nowrap;
					font-weight: 400;
					font-size: 14px;
					height: 40px;
					padding: 0 16px;
					// Deixar flex quando estiver com search ativo, assim resolverá Bruno do futuro
				}
				.vs__selected {
					display: block;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					text-align: left;
	
					width: 100%;
					margin: 0;
					padding: 0;
				}
				.vs__dropdown-toggle {
					display: grid;
					grid-template-columns: minmax(0,1fr) max-content;
		
					height: max-content;
					padding: 0;
					border: 1px solid #D5D5D5;
					input.vs__search {
						border: none;
						font-size: 14px;
						padding: 0;
						text-indent: 0;
						&::placeholder {
							text-indent: 0;
							font-weight: 400;
							font-size: 14px;
							color: #999999;
						}
					}
				}
				.vs__actions {
	
					display: grid;
					place-items: center;
					width: max-content;
				}
				.vs__search {
					margin: 0;
					grid-column: 1/3;
				}
				.vs__no-options {
					display: grid;
					place-items: center;
					font-size: 14px;
					height: 40px;
				}
				.vs__dropdown-menu {
					box-shadow: 0px 0px 1px 0px rgba(48, 49, 51, 0.05), 0px 8px 16px 0px rgba(48, 49, 51, 0.10);
					border: none;
					min-height: 40px;
					border: 1px solid #EEE;
					padding: 0 ;
					.vs__dropdown-option {
						display: flex;
						align-items: center;
						text-wrap: wrap;
						box-sizing: content-box;
						color: #131313;
						min-height: 24px;
						height: max-content;
						padding: 8px 16px;
						&--highlight {
							background-color: #EEE;
						}
					}
					&::-webkit-scrollbar {
						width: 10px;
						border: solid 3px white;
					}
						&::-webkit-scrollbar-thumb {
							background: #EEEEEE;
							padding: 1px;
							border-radius: 8px;
							opacity: 0.7;
							border: solid 3px white;
					}
	
				}
				.vs__open-indicator {
					width: 20px;
					height: 20px;
					object-fit: contain;
				}
	
				.form_error {
					display: block;
					color: $color_error;
					font-size: 14px;
					margin-top: 4px;
				}
	
			}
	
			&[data-error=true] {
				.form__input__select {
	
					.vs__dropdown-toggle {
						border-color: $color_error;
					}
				}
			}
			.form__label {
				font-size: 14px;
				color: #131313;
				font-weight: 400;
				margin-bottom: 4px;
			}
		
		}
	</style>
	
	